import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  Container,
  Row,
  Col,
} from "reactstrap";

// core components
import MainNavbar from "components/Navbars/MainNavbar.js";
import MainFooter from "components/Footers/MainFooter.js";
import MainHeader from "components/Headers/MainHeader";

function AboutMe() {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("about-me");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("about-me");
    };
  });
  return (
    <>
      <MainNavbar />
      <MainHeader title="About" />
      <div className="main">
        <div className="section">
          <Container>
            <h3 className="title-uppercase text-center">
              Shannen's the name, telling stories is the game.
            </h3>
          <Container style={{paddingTop:20}}>
            <Row> 
              <Col sm={4}>
              <img
                alt="Headshot"
                src={require("assets/img/AboutMe1.png")}
                width={300}
                height={300}
              />
              </Col>
              <Col sm={4}>
              <img
                alt="Headshot"
                src={require("assets/img/AboutMe2.png")}
                width={300}
                height={300}
              />
              </Col>
              <Col sm={4}>
              <img
                alt="Headshot"
                src={require("assets/img/AboutMe3.png")}
                width={300}
                height={300}
              />
              </Col>
            </Row>
            </Container>
            <p>
              With a background of choir, theatre, and film, Shannen has been
              performing for their entire life. Inspired by their love of
              animation and video games, they naturally took interest in voice
              over, training through the University of Las Vegas Nevada (UNLV)
              and The Voice Actors’ Studio (TVAS) in order to hone in their craft.
              Whether it's in front of the camera or in the recording booth,
              she loves being able to develop a story behind the text and
              collaborate with others in order to bring a project to life.
              <br />
              <br />
              Residing in Las Vegas, Nevada, they currently work in the activity
              department for memory care, sharing their passion for art, music,
              and film with dementia patients. When she's not in the studio,
              she's probably out thrift shopping, trying to learn a new craft,
              or thinking about dinosaurs.
            </p>
            {/* <h3 className="title-uppercase">
              We
              <i className="fa fa-heart heart mr-3 ml-1" />
              what we do.
            </h3> */}
            <h3>Gear</h3>
            <ul>
              <li>Adobe Audition</li>
              <li>XL V63M</li>
              <li>Alesis Multimix4 USB FX</li>
            </ul>
            <h3>Delivery Methods</h3>
            <ul>
              <li>WAV</li>
              <li>MP3</li>
              <li>Dropbox</li>
              {/* <li>SourceConnect: shannenvelasco_vo</li> */}
            </ul>
          </Container>
        </div>
      </div>
      <MainFooter />
    </>
  );
}

export default AboutMe;
